/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgotpassword1Inputs */

const zh_auth_forgotpassword1 = /** @type {(inputs: Auth_Forgotpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忘记密码？`)
};

const en_auth_forgotpassword1 = /** @type {(inputs: Auth_Forgotpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot Password?`)
};

const es_auth_forgotpassword1 = /** @type {(inputs: Auth_Forgotpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Olvidaste tu contraseña?`)
};

/**
* | output |
* | --- |
* | "Forgot Password?" |
*
* @param {Auth_Forgotpassword1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_forgotpassword1 = /** @type {((inputs?: Auth_Forgotpassword1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgotpassword1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_forgotpassword1(inputs)
	if (locale === "en") return en_auth_forgotpassword1(inputs)
	return es_auth_forgotpassword1(inputs)
});
export { auth_forgotpassword1 as "auth_forgotPassword" }